export default class FormBuilderNodeComponentsController {
	/* @ngInject */
	/**
	 * @param {any} dndDragIframeWorkaround
	 */
	constructor(dndDragIframeWorkaround) {
		this.components = undefined;
		this.dndDragIframeWorkaround = dndDragIframeWorkaround;
	}

	dragstart() {
		this.dndDragIframeWorkaround.isDragging = true
	}

	dragend() {
		this.dndDragIframeWorkaround.isDragging = false
	}
}
